export const name = 'match';

/**
 * @ngdoc directive
 * @name gazelle.components.validation.directive:match
 *
 * @param {string=} the expression to match against
 *
 * @description
 * `match` is an attribute directive used to check string equality between an input field and a specified view model value.
 * For the purposes of setting ngMessage values the following ngModel.NgModelController validity states will be triggered:
 *
 *  `match` if the control model value is not equal to the match expression
 *
 * @usage
 * ```html
 * <input name="confirmPassword" type="password" match="vm.password"></input>
 * ```
 */

export default function match($parse, $log) {

  //noinspection BadExpressionStatementJS
  'ngInject';

  return {
    require: 'ngModel',
    restrict: 'A',
    link: function (scope, elem, attrs, ctrl) {

      //This part does the matching
      scope.$watch(function () {
        return ctrl.$modelValue;
      }, watchListener);

      scope.$watch(attrs.match, watchListener);

      function watchListener() {
        if ($parse(attrs.match)(scope) === ctrl.$modelValue) {
          setMatch(true);
        } else {
          setMatch(false);
        }
      }

      function setMatch(match) {
        ctrl.$setValidity('match', match);
      }
    }
  };
}
